/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */
// import PageScroll from "./modules/PageScroll";
import Tabs from "./modules/Tabs";
import Accordion from "./modules/Accordion";

import WCProductShowMore from "./modules/WCProductShowMore";
import WCProductReviewsSlider from "./modules/WCProductReviewsSlider";
import WCProductCustomTypesSelect from "./modules/WCProductCustomTypesSelect";
import WCProductCustomDateSelector from "./modules/WCProductCustomDateSelector";
import WCProductCalendar from "./modules/WCProductCalendar";
import AskQuestion from "./modules/AskQuestion";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const trainigScopeAccordion = document.querySelector(
        ".jsTrainingAccordion",
    );

    if (trainigScopeAccordion) {
        const myTrainigScopeAccordion = new Accordion(trainigScopeAccordion, {
            accordionOpenOnInit: true,
            allowOpeningAll: true,
        });
    }

    const elearningScopeAccordion = document.querySelector(
        ".jsElearningAccordion",
    );

    if (elearningScopeAccordion) {
        const myElearningScopeAccordion = new Accordion(
            elearningScopeAccordion,
            {
                allowOpeningAll: true,
            },
        );

        const trainingTopicsAccordions = [
            ...elearningScopeAccordion.querySelectorAll(".jsTopicsAccordion"),
        ];

        if (trainingTopicsAccordions.length) {
            trainingTopicsAccordions.forEach((topic) => {
                const myTopicAccordion = new Accordion(topic, {
                    btnClass: "jsTopicsnBtn",
                    contentClass: "jsTopicsContent",
                    openAllBtnClass: "jsAccordionOpenAllBtns",
                    allowOpeningAll: true,
                });
            });
        }
    }

    const myWCProductShowMore = new WCProductShowMore();
    const myWCProductReviewsSlider = new WCProductReviewsSlider();
    const myCoursesTabs = new Tabs("jsCourseDatesTabs");
    const myWCProductCustomTypesSelect = new WCProductCustomTypesSelect();
    const myWCProductCustomDateSelector = new WCProductCustomDateSelector();
    const myWCProductCalendar = new WCProductCalendar();
    const myAskQuestion = new AskQuestion();
});
